"use client";

import { useEffect, useState } from "react";
import Image from "next/image";

const STATUSES = [
  "Düşünüyor...",
  "Ürün arıyor...",
  "Seçenekler hazırlanıyor...",
  "Yanıt oluşturuluyor...",
];

interface TozyTypingIndicatorProps {
  icon: string;
  pendingMessage?: string;
}

const TozyTypingIndicator = ({ icon, pendingMessage }: TozyTypingIndicatorProps) => {
  const [statusIdx, setStatusIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStatusIdx((i) => (i + 1) % STATUSES.length);
    }, 1800);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex flex-col gap-2">
      {pendingMessage && (
        <div className="flex justify-end">
          <div className="max-w-[78%] bg-brand text-white rounded-2xl rounded-tr-sm px-4 py-3 text-sm leading-relaxed">
            {pendingMessage}
          </div>
        </div>
      )}

      <div className="flex gap-3 items-start">
        <div className="w-8 h-8 rounded-xl bg-brand flex items-center justify-center shrink-0 overflow-hidden mt-0.5">
          <Image src={icon} alt="Tozzy" width={20} height={20} className="object-contain" />
        </div>
        <div className="bg-gray-100 rounded-2xl rounded-tl-sm px-4 py-3 flex items-center gap-3">
          <div className="flex items-center gap-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-1.5 h-1.5 rounded-full bg-brand animate-bounce"
                style={{ animationDelay: `${i * 0.18}s` }}
              />
            ))}
          </div>
          <span
            key={statusIdx}
            className="text-xs text-gray-400 animate-pulse"
          >
            {STATUSES[statusIdx]}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TozyTypingIndicator;